import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { CLIENT_ROUTES, ROLES_NAMES, SCOPE_TYPE } from "../enums/Enums";
import { NAVIGATION_ITEMS } from "../constants/Constants";
import { getSitesUnderSelectedScope, isAllowedForAdminArea } from "../utils/UsersUtils";

const RequireAuth = (props) => {
  const allScopes = useSelector((state) => state.user?.allScopes);
  const sites = useSelector((state) => state.user?.sites);
  const roles = useSelector((state) => state?.user?.initialState?.roles);
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const selectedSites = getSitesUnderSelectedScope(sites, allScopes, selectedScope);
  const isUserLoggedIn = useSelector((state) => state.user?.isUserLoggedIn);
  const gmtUser = useSelector((state) => state.user?.gmtUser);
  const isChargeAccount = gmtUser?.userIdentity?.userScopes?.some(us => us?.role?.name === ROLES_NAMES.CHARGE_ACCOUNT);
  const isAdminAreaAllowed = isAllowedForAdminArea(gmtUser?.userIdentity?.userScopes, selectedScope, allScopes, roles);
  const isMessagingAreaAllowed = isAdminAreaAllowed && (selectedScope?.type === SCOPE_TYPE.PROJECT && selectedSites?.some(se => se?.isMessagingEnabled));
  const navItems = NAVIGATION_ITEMS.map(ni => ni.link);
  const location = useLocation();

  if (!isUserLoggedIn) {
    return (
      <Navigate to={CLIENT_ROUTES.LOGIN} state={{ from: location }} replace />
    );
  }

  // if charge account user trying to reach other routes than Validations / History allowed area, redirect to Validations
  if (isChargeAccount && navItems.some(ni => ni === location?.pathname && location?.pathname !== CLIENT_ROUTES.VALIDATIONS && location?.pathname !== CLIENT_ROUTES.HISTORY)) {
    return (
      <Navigate to={CLIENT_ROUTES.VALIDATIONS} state={{ from: location }} replace />
    );
  }

  // if not a charge account user trying to reach Validations / History area, redirect to Parkers
  if (!isChargeAccount && navItems.some(ni => ni === location?.pathname && location?.pathname === CLIENT_ROUTES.VALIDATIONS || location?.pathname === CLIENT_ROUTES.HISTORY)) {
    return (
      <Navigate to={CLIENT_ROUTES.PARKERS} state={{ from: location }} replace />
    );
  }

  // if user trying to reach Admin area while doesnt have admin role, redirect to Parkers
  if (!isAdminAreaAllowed && 
      navItems.some(ni => ni === location?.pathname && location?.pathname === CLIENT_ROUTES.ADMIN || location?.pathname === CLIENT_ROUTES.WORKSPACE)) {
    return (
      <Navigate to={CLIENT_ROUTES.PARKERS} state={{ from: location }} replace />
    );
  }

  // if user trying to reach Messaging area while doesnt have admin role / admin role exists & selected scope is not project or messaging is not enabled on site, redirect to Parkers
  if (!isMessagingAreaAllowed && 
      navItems.some(ni => ni === location?.pathname && location?.pathname === CLIENT_ROUTES.MESSAGING)) {
    return (
      <Navigate to={CLIENT_ROUTES.PARKERS} state={{ from: location }} replace />
    );
  }

  return props.children;
};

export default RequireAuth;
